interface IconProps {
  name: string;
  filled?: boolean;
  size?: number;
  weight?: 300 | 400 | 500 | 600 | 700;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Material Symbols Outlined icon. Single-source-of-truth glyph component.
 * Stitch / Google's Material Symbols pair beautifully with Playfair + Raleway.
 */
export default function Icon({
  name,
  filled = false,
  size = 22,
  weight = 400,
  color,
  className = "",
  style,
}: IconProps) {
  return (
    <span
      className={`mnf-icon ${filled ? "filled" : ""} ${className}`}
      style={{
        fontSize: size,
        color: color ?? "inherit",
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
        ...style,
      }}
      aria-hidden
    >
      {name}
    </span>
  );
}
